import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { BookingSystemAPI } from '../services/BookingSystemAPI';
import './VerifyEmail.css';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'verifying' | 'success' | 'already' | 'error'>('verifying');
  const [message, setMessage] = useState('E-Mail wird verifiziert...');

  // StrictMode-Guard: Verhindert doppelten API-Call
  const hasCalledRef = useRef(false);

  useEffect(() => {
    if (hasCalledRef.current) return;
    hasCalledRef.current = true;

    const verifyEmail = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setStatus('error');
        setMessage('Kein Verifizierungstoken gefunden.');
        return;
      }

      try {
        const api = new BookingSystemAPI();
        const result = await api.verifyEmail(token);

        if (result.success) {
          if (result.alreadyVerified) {
            setStatus('already');
            setMessage('Ihre E-Mail-Adresse wurde bereits bestätigt.');
          } else {
            setStatus('success');
            setMessage(result.message || 'E-Mail-Adresse erfolgreich bestätigt!');
          }
          setTimeout(() => navigate('/login'), 3000);
        } else {
          setStatus('error');
          setMessage(result.message || 'Verifizierung fehlgeschlagen.');
        }
      } catch (error: any) {
        setStatus('error');
        setMessage(error.message || 'Ein Fehler ist aufgetreten.');
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div className="verify-email-container">
      <div className="verify-email-card">
        {/* Logo */}
        <div className="verify-email-logo">
          <span className="verify-email-logo-text">Frankenfloß</span>
        </div>

        <div className={`verify-email-icon ${status}`}>
          {status === 'verifying' && (
            <div className="spinner"></div>
          )}
          {status === 'success' && (
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          )}
          {status === 'already' && (
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          )}
          {status === 'error' && (
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          )}
        </div>

        <h1 className="verify-email-title">
          {status === 'verifying' && 'E-Mail-Verifizierung'}
          {status === 'success' && 'Erfolgreich verifiziert!'}
          {status === 'already' && 'Bereits verifiziert'}
          {status === 'error' && 'Verifizierung fehlgeschlagen'}
        </h1>

        <p className="verify-email-message">{message}</p>

        {(status === 'success' || status === 'already') && (
          <p className="verify-email-redirect">
            Sie werden in wenigen Sekunden zur Anmeldung weitergeleitet...
          </p>
        )}

        {status === 'error' && (
          <button
            className="verify-email-button"
            onClick={() => navigate('/login')}
          >
            Zur Anmeldung
          </button>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
